<template>
  <div class="fixed container align-center" v-if="showModal">
    <div class="modal-answer">
      <div class="modal-answer__title">
        <h1>{{question.question}}</h1>
      </div>

      <div class="modal-answer__content">
        <ul class="list-style-none modal-answer__content__questions">
          <li
            v-for="(answr, index) in question.answers"
            :class="{
              correct: answr.correct && question.answered,
              wrong: !answr.correct && question.answered && answr.selected,
              selected: answr.selected
            }"
            :key="`answer-${index}`"
            @click="select(answr)"
          >
            <div class="container align-items-center">
              <div class="ball" :class="{active : answr.selected}"></div>
              {{ answr.text }}
            </div>
          </li>
        </ul>
      </div>

      <div class="modal-answer__btn margin-top-20">
        <button
          type="button"
          name="button"
          class="btn btn-rounded btn-full btn-gradient-orange"
          @click="nextQuestion()"
        >Continuar vídeo</button>
      </div>
    </div>
  </div>
</template>
<script>
import gameBus from "@/components/game/gameBus";
import answerBus from "./bus";
import { mapGetters } from "vuex";

export default {
  name: "Answers",
  data() {
    return {
      showModal: false
    };
  },
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    exercise: {
      type: Object,
      default: () => ({ video: '', questions: [] })
    },
    feedback: {
      type: Function,
      default: () => console.log('Show Feedback')
    },
    showInfo: {
      type: Function,
      default: () => console.log('Show Info Modal')
    }
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    })
  },
  methods: {
    async select(answer) {
      if (!this.question.answered) {
        this.$set(this.question, "answered", true);
        this.$set(answer, "selected", true);
        if (answer.correct) this.$set(this.question, "hit", true);
        else this.$set(this.question, "hit", false);
        this.feedback()
        await this.save(this.question);
      }
    },
    show() {
      this.showModal = true;
    },
    nextQuestion() {
      answerBus.$emit("play");
      this.showModal = false;
    },
    async save(question) {
      let scoreQuestions = 0;
      let answered = 0;

      for (const qst of this.exercise.questions) {
        for (const aswr of qst.answers) {
          if (aswr.selected && aswr.correct) scoreQuestions++;
        }
        if (qst.answered) answered++;
      }

      const score = (scoreQuestions * 100) / this.exercise.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      };

      if (answered == this.exercise.questions.length) {
        payload.finished = true;
        gameBus.$emit("setEnded", true);
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit("updateProgress", score);
      gameBus.$emit("setEnabled", true);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    }
  },
  mounted() {
    answerBus.$on("show", this.show);
  },
  beforeDestroy() {
    answerBus.$off("show", this.show);
  }
};
</script>
<style lang="scss" scoped>
.fixed {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 100%;
  z-index: 100;
}

.modal-answer {
  background: #fff;
  border-radius: 4px;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
  max-height: calc(100% - 40px);
  overflow-y: auto;

  h1 {
    line-height: 1.1;
    font-size: 1rem;
    color: #0f4f8f;
  }
  &__title {
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #82b8ff;
    width: 100%;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  &__btn {
    min-height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__content {
    &__questions {
      text-align: left;
      display: flex;
      flex-wrap: wrap;

      li {
        border: 1px solid #979797;
        background: #d8d8d8;
        border-radius: 150px;
        list-style: none;
        padding: 10px;
        margin-top: 10px;
        width: calc(50% - 10px);
        margin: 5px;
        cursor: pointer;
        &:hover {
          background: #c0c0c0;
        }

        .ball {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin-right: 10px;
          box-shadow: 0 0 0 2px #979797;
          position: relative;

          &.active {
            background: #ddd;

            &.correct {
              background: #79940d;
              box-shadow: 0 0 0 2px #79940d;
            }

            &.wrong {
              background: #d62727;
              box-shadow: 0 0 0 2px #d62727;
            }
          }
        }

        &.correct {
          color: #79940d;
          font-weight: bold;
          background: #dffb6c;
          .ball {
            background: #abc92e;
            box-shadow: 0 0 0 2px #79940d;
          }
        }

        &.wrong {
          color: #d62727;
          font-weight: bold;
          background: #eb8787;
          .ball {
            background: #eb8787;
            box-shadow: 0 0 0 2px #d62727;
          }
        }
        &.selected {
          .ball {
            background: #4393D9;
            box-shadow: 0 0 0 2px #979797;
            border: 2px solid #fff;
          }
        }
      }

      label {
        font-size: 1rem;
        line-height: 1.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/GameComponents/Answers/index.vue